export default __webpack_public_path__ + "static/media/icon-karma.24e0debe.svg";